module.exports = __webpack_public_path__ + "static/media/lockIcon.21d6b6ae.svg";